export type FnaPresentationVariant = "legacy" | "zuu";

export function resolveFnaPresentationVariant(input: {
  brandId?: string | null;
  tenantCode?: string | null;
}): FnaPresentationVariant {
  if (input.brandId === "zuu" || input.tenantCode === "zuu") {
    return "zuu";
  }

  return "legacy";
}

export function isZuuFnaVariant(input: {
  brandId?: string | null;
  tenantCode?: string | null;
}): boolean {
  return resolveFnaPresentationVariant(input) === "zuu";
}

export function isZuuFinancialStepVariant(input: {
  brandId?: string | null;
  tenantCode?: string | null;
}): boolean {
  return isZuuFnaVariant(input);
}
